






















	import Vue from 'vue';
    import ListAnmeldungEintragComp from "./ListAnmeldungEintragComp.vue";

    export default Vue.extend({
        name: "ListAnmeldungComp",
        components: {ListAnmeldungEintragComp},
        data: () => ({
            open: undefined,
        }),
        computed: {
            anmeldungen: function() {
              return this.$vStore.getters.anmeldungen;
            },
            yesCount: function(): number {
                return this.anmeldungen.filter((a: any) => a.type === 0).length;
            },
            maybeCount: function(): number {
                return this.anmeldungen.filter((a: any) => a.type === 1).length;
            },
            falseCount: function(): number {
                return this.anmeldungen.filter((a: any) => a.type === 2).length;
            },
            anmeldungCount: function(): number[] {
                return [this.yesCount, this.maybeCount, this.falseCount];
            },
            showDetailsInHeader: function(): boolean {
                return this.$vStore.getters.windowWidth > 500;
            }
        },
        methods: {
            anmeldungIcon: function(type: number): string {
                const icons = ['check_circle', 'check_circle_outline', 'cancel', 'help'];
                return icons[type];
            },
            anmeldungColor: function(type: number): string {
                const colors = ['green', 'yellow', 'red', 'grey'];
                return colors[type];
            }
        }
    })
